import styled from "styled-components"
import {
  validColor,
  darkBorder,
  darkFontColor,
  darkBackground,
} from "./helpers"

export const StyledInputWrapper = styled.div`
  /* display: ${({ hidden }) => (hidden ? "none;" : "inline-block;")} */
  ${({ hidden }) =>
    hidden
      ? `
        display: none;
        height: 0;
        width: 0;
    `
      : `
        display: inline-block;
    `}
  width: ${({ half }) => (half ? "50%;" : "100%;")}
    float: ${({ half }) => (half ? "left;" : "inherit;")}
    margin: .8rem 0;
  position: relative;

  & label {
    width: 100%;
    font-size: 14px;
    font-family: "EFCircularWeb-Book";
    line-height: 1;
    padding: 0 1.6rem 0 0;
    display: flex;
    justify-content: space-between;
    color: ${({ isDark }) => darkFontColor(isDark)};
    @media (max-width: 1024px) {
      font-size: 12px;
      padding: 0 1.3rem 0 0;
    }

    & span {
      color: #ee6160;
      font-family: "EFCircularWeb-Book";
    }
  }

  ${(props) =>
    props.loading &&
    `
        opacity: .5;
        pointer-events: none;
    `}
`

export const StyledInput = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  background: ${({ isDark }) => darkBackground(isDark)};
  border-radius: 4px;
  margin: 0.4rem 0 0 0;
  height: 100%;
  width: 100%;
  position: relative;
  border: 1px solid ${({ isDark }) => darkBorder(isDark)};

  & input,
  & textarea {
    width: 100%;
    min-height: 54px;
    font-family: "EFCircularWeb-Book";
    line-height: 1.2;
    padding: 1.6rem;
    font-size: 16px;
    margin: 0;
    -webkit-appearance: none;
    @media (max-width: 1024px) {
      min-height: 44px;
      font-size: 14px;
      padding: 1.3rem;
    }
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px ${({ isDark }) => darkBackground(isDark)}
        inset !important;
    }
    &::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      color: rgba(43, 43, 43, 0.3);
      font-style: italic;
    }
    &::-moz-placeholder {
      /* Firefox 19+ */
      color: rgba(43, 43, 43, 0.3);
      font-style: italic;
    }
    &:-ms-input-placeholder {
      /* IE 10+ */
      color: rgba(43, 43, 43, 0.3);
      font-style: italic;
    }
    &:-moz-placeholder {
      /* Firefox 18- */
      color: rgba(43, 43, 43, 0.3);
      font-style: italic;
    }
  }
  & textarea {
    line-height: 1.2;
  }
`
